import React from 'react';
import SectorsListItem from './SectorsListItem/SectorsListItem';

interface Props {
  items: Array<string>;
}

const SectorsList = ({ items }: Props) => {
  const sectorsMapper = (item: string, index: number) => <SectorsListItem key={index}>{item}</SectorsListItem>;
  return <ul>{items.map(sectorsMapper)}</ul>;
};

export default SectorsList;
